import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as ExpandLess } from '../../../../../../assets/icons/expand_less.svg';
import { ReactComponent as ExpandMore } from '../../../../../../assets/icons/expand_more.svg';
import { INavbarMenuItem, INavbarSubmenuItem } from '../../../../../interfaces/appNavbar';
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem';

import './SidebarNavGroup.scss';

interface SidebarNavGroupProps {
  item: INavbarMenuItem;
  isExpanded: boolean;
  isOpen: boolean;
  active: boolean;
  isSubItemActive: (subItem: INavbarSubmenuItem) => boolean;
  onToggle: () => void;
  onSelect: (subItem: INavbarSubmenuItem) => void;
}

const SidebarNavGroup = ({
  item,
  isExpanded,
  isOpen,
  active,
  isSubItemActive,
  onToggle,
  onSelect
}: SidebarNavGroupProps) => {
  const { t } = useTranslation();
  const showSubmenu = isExpanded && isOpen;
  const Chevron = showSubmenu ? ExpandLess : ExpandMore;

  return (
    <div className={`sidebar-nav-group ${showSubmenu ? 'open' : ''}`}>
      <SidebarNavItem
        icon={item.iconComponent}
        iconTitle={`item-img-${item.id}`}
        label={t(item.title)}
        isExpanded={isExpanded}
        active={active}
        ariaExpanded={showSubmenu}
        onClick={onToggle}
        trailing={<Chevron className="sidebar-nav-group-chevron" aria-hidden="true" />}
      />
      {showSubmenu && (
        <div className="sidebar-nav-group-submenu">
          {item.submenu?.items.map((subItem) => {
            const subItemActive = isSubItemActive(subItem);
            return (
              <button
                key={`desktop-${subItem.id}`}
                type="button"
                className={`sidebar-nav-group-subitem ${subItemActive ? 'active' : ''}`}
                aria-current={subItemActive ? 'page' : undefined}
                onClick={() => onSelect(subItem)}
              >
                {t(subItem.title)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SidebarNavGroup;
